export default __webpack_public_path__ + "static/media/greenMarker.e7ab1400.svg";